import { useState } from "react";
import { conditions } from "../../../../../helpers";
import { ConditionName, zIndex } from "../../../../../interfaces";
import { handleSendVoucher } from "../../../../../redux/actions/user.actions";

const Voucher = () => {

    const [inputValue, setInputValue] = useState<string>("");

    return (
        <div className={`pl-flex pl-justify-center pl-items-center pl-w-full pl-h-full pl-absolute`} style={{zIndex: zIndex.voucher}}>
            <div className="pl-absolute pl-w-full pl-h-full pl-bg-transparent pl-backdrop-blur-[5px]"/>
            <div className={`pl-w-full pl-max-w-[639px] pl-bg-white/[0.9] dark:pl-bg-dark-3/[0.9] pl-rounded-[8px] ${conditions(ConditionName.isTouchScreenPortrait) && "pl-pt-[10px] pl-h-full"}`} style={{ boxShadow: conditions(ConditionName.isTouchScreenPortrait) ? "unset" : "0px 4px 4px 0px rgba(0, 0, 0, 0.25)", zIndex: zIndex.voucher }}>
                <p className={`pl-text-[18px] pl-font-bold ${conditions(ConditionName.isTouchScreenPortrait) ? "pl-px-4 pl-pb-4 pl-mb-4" : "pl-p-6"}`} style={{ boxShadow: "0px 8px 20px 0px rgba(178, 191, 205, 0.16)"}}>لطفا کد تماشا را وارد کنید</p>
                <form className={`pl-w-full pl-flex pl-flex-col ${conditions(ConditionName.isTouchScreenPortrait) ? "pl-gap-1 pl-px-4" : "pl-gap-3 pl-px-6 pl-py-8"}`} onSubmit={(event:any) => handleSendVoucher(inputValue,event)}>
                    <input
                        type="text"
                        placeholder="کد تماشا را وارد کنید"
                        className={`pl-outline-0 pl-bg-secondary-200 dark:pl-bg-dark-1 pl-w-full pl-rounded-[10px] pl-p-4 pl-text-center ${conditions(ConditionName.isTouchScreenPortrait) ? "pl-my-3" : "pl-mb-[35px]"}`}
                        onChange={(event: any) => setInputValue(event.target.value)}
                        style={{ direction: "ltr" }}
                    />
                    <button disabled={!inputValue} type="submit" className="!pl-bg-main hover:!pl-bg-main-700 disabled:!pl-bg-main disabled:!pl-opacity-50 pl-duration-300 pl-transition-colors pl-text-white pl-p-4 pl-rounded-[8px]">ارسال کد تماشا</button>
                </form>
            </div>
        </div>
    )
}

export default Voucher;